<template>
    <div>
        <div v-for="(header, index) in tabs" :key="index" v-if="header.id === activeTab">
            <slot v-bind:name="header.id"></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'tabulatedPages',
  props: [
    'tabs',
    'active'
  ],
  data () {
    return {
      activeTab: this.active
    }
  },
  watch: {
    active () {
      this.activeTab = this.active
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
